import { useContext } from 'react';
import { useStore } from 'zustand/index';

import { ValidationConfigContext, ValidationConfigState } from './validationConfigStore';

export function useValidationConfigStore<T>(selector: (state: ValidationConfigState) => T): T {
  const store = useContext(ValidationConfigContext);
  if (!store) throw new Error('Missing ValidationConfigContext.Provider in the tree');
  return useStore(store, selector);
}
